import type { ReactNode } from "react";

import { useCurrentAdmin } from "../auth/useCurrentAdmin";

/**
 * Fails closed: if the current admin is unknown OR their role is not in the
 * allow-list, render nothing. Used to gate menu entries, page chrome, and
 * destructive controls (新建 / 删除 / 重置密码 …).
 *
 * Note: this is UI-only — the API still enforces the same matrix server-side
 * via `requireRole(...)`, so a malicious caller cannot bypass the guard.
 */
export function RoleGuard({
  roles,
  children,
}: {
  roles: string[];
  children: ReactNode;
}) {
  const me = useCurrentAdmin();
  if (!me || !roles.includes(me.role)) return null;
  return <>{children}</>;
}
